import { Box } from "@chakra-ui/react";
import React from "react";

export const Container = (props) => (
    <Box w="full" mx="auto" maxW="3x1" px={{ base: "0", md: "8" }} {...props} />
);

export default Container;
